'use strict';

var _map = require('babel-runtime/core-js/map');

var _map2 = _interopRequireDefault(_map);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SplitCacheInMemory = function () {
  function SplitCacheInMemory() {
    (0, _classCallCheck3.default)(this, SplitCacheInMemory);

    this.flush();
  }

  (0, _createClass3.default)(SplitCacheInMemory, [{
    key: 'addSplit',
    value: function addSplit(splitName, split) {
      this.splitCache.set(splitName, split);

      return true;
    }
  }, {
    key: 'addSplits',
    value: function addSplits(entries) {
      var results = [];

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)(entries), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref = _step.value;

          var _ref2 = (0, _slicedToArray3.default)(_ref, 2);

          var key = _ref2[0];
          var value = _ref2[1];

          results.push(this.addSplit(key, value));
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return results;
    }
  }, {
    key: 'removeSplit',
    value: function removeSplit(splitName) {
      this.splitCache.delete(splitName);

      return 1;
    }
  }, {
    key: 'removeSplits',
    value: function removeSplits(splitNames) {
      var _this = this;

      splitNames.forEach(function (n) {
        return _this.splitCache.delete(n);
      });

      return splitNames.length;
    }
  }, {
    key: 'getSplit',
    value: function getSplit(splitName) {
      return this.splitCache.get(splitName);
    }
  }, {
    key: 'setChangeNumber',
    value: function setChangeNumber(changeNumber) {
      this.changeNumber = changeNumber;

      return true;
    }
  }, {
    key: 'getChangeNumber',
    value: function getChangeNumber() {
      return this.changeNumber;
    }
  }, {
    key: 'getAll',
    value: function getAll() {
      return [].concat((0, _toConsumableArray3.default)(this.splitCache.values()));
    }
  }, {
    key: 'getKeys',
    value: function getKeys() {
      return [].concat((0, _toConsumableArray3.default)(this.splitCache.keys()));
    }
  }, {
    key: 'flush',
    value: function flush() {
      this.splitCache = new _map2.default();
      this.changeNumber = -1;
    }
  }]);
  return SplitCacheInMemory;
}();

module.exports = SplitCacheInMemory;


//////////////////
// WEBPACK FOOTER
// ./~/@splitsoftware/splitio/lib/storage/SplitCache/InMemory.js
// module id = 727
// module chunks = 10